// import { Button, Grid, Paper, Switch, Typography } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import WSTextField, { TextType } from "../../../Components/TextBox/WSTextBox";
// import WSSelectField from "../../../Components/Select/WSSelect";
// import { Controller, useForm } from "react-hook-form";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
// import { useNavigate, useParams } from "react-router-dom";
// import WSTextAreaField from "../../../Components/WSTextArea/WSTextArea";
// import WSButton from "../../../Components/Button/WSButton";
// import WSBackButton from "../../../Components/BackButton/BackButton";
// import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";
// import ParametersViewDrawer from "./ParametersView";
// import clientconfig from "../../../Config/clientConfig.json";
// import {
//   callAPI,
//   getLocalValue,
//   LoacalVariables,
//   Method,
// } from "../../../commonFunctions/CommonFunctions";
// import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
// import WSHiddenField from "../../../Components/HiddenField/WSHiddenField";

// interface LabTestFormData {
//   labId: string;
//   name: string;
//   alsoKnownAs: string;
//   labCategoryId: string | null;
//   testType: string;
//   mrpPrice: string;
//   discountPercentage: string;
//   preparationInstructions: string;
//   turnaroundTime: string;
//   sampleRequired: string;
//   numberOfSubTests: string;
//   isHomeCollectionAvailable: boolean;
//   aboutTest: string;
//   whyChooseTest: string;
//   isRecommended: boolean;
//   isActive: boolean;
// }

// export const LabTestPackage: React.FC<any> = React.memo((props) => {
//   const methods = useForm<LabTestFormData>({
//     defaultValues: {
//       labId: "",
//       name: "",
//       alsoKnownAs: "",
//       labCategoryId: null,
//       testType: "",
//       mrpPrice: "",
//       discountPercentage: "",
//       preparationInstructions: "",
//       turnaroundTime: "",
//       sampleRequired: "",
//       numberOfSubTests: "",
//       isHomeCollectionAvailable: false,
//       aboutTest: "",
//       whyChooseTest: "",
//       isRecommended: false,
//       isActive: true,
//     },
//   });

//   const {
//     control,
//     register,
//     handleSubmit,
//     setValue,
//     reset,
//     watch,
//     formState: { errors },
//   } = methods;

//   const [loading, setLoading] = useState<boolean>(false);
//   const navigate = useNavigate();
//   const [open, setOpen] = React.useState(false);
//   const [formComponent, setFormComponent] = useState<any>();
//   const [labId, setLabId] = useState<string>("");
//   const { showMessage } = useSnackbar();
//   const params = useParams();
//   const id = params?.id;

//   // Set labId FIRST
//   useEffect(() => {
//     console.log("🎯 STEP 1 - Setting labId. ID:", id);
//     const userId = getLocalValue(LoacalVariables.UserId) || "";
//     const finalLabId = id || userId || "";
//     console.log("🔗 Final labId:", finalLabId);
//     setLabId(finalLabId);
//     if (finalLabId) {
//       setValue("labId", finalLabId);
//     }
//   }, [id, setValue]);

//   // Load edit data SECOND
//   useEffect(() => {
//     if (!id || !labId) {
//       console.log("⏳ No ID or labId yet");
//       return;
//     }

//     let isCurrent = true;
//     const loadData = async () => {
//       try {
//         setLoading(true);
//         console.log("🚀 FETCHING:", `lab/LabService/${id}`);
//         const response = await callAPI(`lab/LabService/${id}`, Method.GET);
//         console.log("✅ RESPONSE:", response?.data);

//         const data = response?.data || response;
//         if (data && isCurrent) {
//           const formData = {
//             labId: data.labId || labId,
//             name: data.name || "",
//             alsoKnownAs: data.alsoKnownAs || "",
//             labCategoryId: data.labCategoryId || null,
//             testType: data.testType || "",
//             mrpPrice: data.mrpPrice?.toString() || "0",
//             discountPercentage: data.discountPercentage?.toString() || "0",
//             preparationInstructions: data.preparationInstructions || "",
//             turnaroundTime: data.turnaroundTime || "",
//             sampleRequired: data.sampleRequired || "",
//             numberOfSubTests: data.numberOfSubTests?.toString() || "0",
//             isHomeCollectionAvailable: Boolean(data.isHomeCollectionAvailable),
//             aboutTest: data.aboutTest || "",
//             whyChooseTest: data.whyChooseTest || "",
//             isRecommended: Boolean(data.isRecommended),
//             isActive: data.isActive !== undefined ? Boolean(data.isActive) : true,
//           };
//           console.log("📝 POPULATING FORM:", formData);
//           reset(formData);
//         }
//       } catch (error: any) {
//         console.error("💥 ERROR:", error);
//         showMessage(error?.response?.data?.message || "Failed to load data", "error");
//       } finally {
//         if (isCurrent) setLoading(false);
//       }
//     };

//     loadData();
//     return () => { isCurrent = false; };
//   }, [id, labId, reset, showMessage]);

//   useEffect(() => {
//     breadCrumbsStore.updateBreadCrumbs([
//       { "Lab Test & Packages": "labtestpackage/list" },
//       { [id ? "Update Test / Package / Scan" : "Add New Test / Package / Scan"]: "/" },
//     ]);
//   }, [id]);

//   const categorySource = {
//     url: "lab/LabCategory/search",
//     page: 1,
//     pageSize: 10,
//     filter: [],
//     sort: [],
//   };

//   const transFormDataCategory = (data: any) => {
//     const category: Array<any> = [];
//     if (data) {
//       data.map((item: any) => category.push({ label: item.name, value: item.id }));
//     }
//     return category;
//   };

//   const handleCancelClick = () => navigate("/labtestpackage/list");

//   const handleView = () => {
//     const form: any = (
//       <ParametersViewDrawer
//         id="parametersAdd"
//         control={control}
//         register={register}
//         reset={reset}
//         setValue={setValue}
//         onCancel={() => {
//           reset();
//           setOpen(false);
//           setFormComponent(null);
//         }}
//       />
//     );
//     setFormComponent(form);
//     setTimeout(() => setOpen(true), 10);
//   };

//   const saveData = async (data: LabTestFormData) => {
//     const requestBody = {
//       labId: data.labId || labId || "",
//       name: data.name.trim(),
//       alsoKnownAs: data.alsoKnownAs.trim(),
//       labCategoryId: data.labCategoryId || "",
//       testType: data.testType,
//       mrpPrice: parseFloat(data.mrpPrice) || 0,
//       discountPercentage: parseFloat(data.discountPercentage) || 0,
//       preparationInstructions: data.preparationInstructions.trim(),
//       turnaroundTime: data.turnaroundTime.trim(),
//       sampleRequired: data.sampleRequired.trim(),
//       numberOfSubTests: parseInt(data.numberOfSubTests) || 0,
//       isHomeCollectionAvailable: data.isHomeCollectionAvailable,
//       aboutTest: data.aboutTest.trim(),
//       whyChooseTest: data.whyChooseTest.trim(),
//       isRecommended: data.isRecommended,
//       isActive: data.isActive,
//     };

//     try {
//     let response: any;
//     if (id) {
//       // ✅ FIX: Use URL path like GET request
//       response = await callAPI(`lab/LabService/${id}`, Method.PUT, requestBody);
//       console.log("putres",response);
      
//     } else {
//       response = await callAPI("lab/LabService", Method.POST, requestBody);
//     }
//     return response?.data || response || { success: true };
//   } catch (error: any) {
//     throw new Error(error?.response?.data?.message || error.message || "Save failed");
//   }
// };

//   const handleData = async (data: LabTestFormData) => {
//     try {
//       setLoading(true);
//       await saveData(data);
//       showMessage(id ? "Updated successfully!" : "Created successfully!", "success");
//       navigate("/labtestpackage/list");
//     } catch (error: any) {
//       showMessage(error.message || "Save failed", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <WSBackButton id="btnScheduleBack" url="/labtestpackage/list" />
      
//       {/* 🔍 DEBUG PANEL */}
//       {/* <Paper elevation={2} sx={{ p: 2, mt: 2, mb: 2, backgroundColor: '#e3f2fd' }}>
//         <Typography variant="h6">🔍 DEBUG</Typography>
//         <Grid container spacing={1}>
//           <Grid item xs={6}><strong>ID:</strong> {id || 'NONE'}</Grid>
//           <Grid item xs={6}><strong>Lab ID:</strong> {labId || 'NONE'}</Grid>
//           <Grid item xs={6}><strong>Loading:</strong> {loading.toString()}</Grid>
//           <Grid item xs={6}><strong>Name:</strong> {watch("name") || 'EMPTY'}</Grid>
//         </Grid>
//       </Paper> */}

//       <form onSubmit={handleSubmit(handleData)}>
//         {/* ✅ ALL FIELDS HAVE id PROPS */}
//         <Paper elevation={0} style={{ padding: 20, marginTop: 20, borderRadius: "8px" }}>
//           <Grid container spacing={2}>
//             <Grid item xs={12}>
//               <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Basic Information</Typography>
//             </Grid>
//             <WSHiddenField control={control} name="labId" />
            
//             <Grid item xs={12} sm={10}>
//               <WSTextField
//                 id="name-field"          
//                 control={control}
//                 name="name"
//                 rules={{ required: "Name is required" }}
//                 label="Name *"
//               />
//             </Grid>

//             <Grid item xs={12} sm={2}>
//               <WSSelectField
//                 id="testType"       
//                 control={control}
//                 rules={{ required: "Test type is required" }}
//                 name="testType"
//                 label="Type *"
//                 options={clientconfig.typeConfig.staticOptionData}
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <WSTextField
//                 id="alsoKnownAs-field"    // ✅ ADDED
//                 control={control}
//                 name="alsoKnownAs"
//                 rules={{ required: "Also known as is required" }}
//                 label="Also Known As *"
//               />
//             </Grid>

//             <Grid item xs={12} sm={4}>
//               <WSSelectField
//                 id="labCategoryId"  // ✅ ADDED
//                 control={control}
//                 rules={{ required: "Category is required" }}
//                 name="labCategoryId"
//                 source={categorySource}
//                 transFormData={transFormDataCategory}
//                 label="Category *"
//               />
//             </Grid>
//           </Grid>
//         </Paper>

//         {/* Pricing & Preparation */}
//         <Grid container spacing={2} mt={2}>
//           <Grid item xs={12} sm={4}>
//             <Paper elevation={0} style={{ padding: 20, borderRadius: "8px" }}>
//               <Typography sx={{ fontSize: "1rem", fontWeight: "bold", mb: 2 }}>Pricing</Typography>
//               <Grid container spacing={2}>
//                 <Grid item xs={12} sm={6}>
//                   <WSTextField
//                     id="mrpPrice-field"       // ✅ ADDED
//                     control={control}
//                     name="mrpPrice"
//                     rules={{
//                       required: "MRP Price is required",
//                       pattern: { value: /^[0-9]+(\.[0-9]{1,2})?$/, message: "Enter valid price" },
//                     }}
//                     label="MRP Price *"
//                     type={TextType.Number}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <WSTextField
//                     id="discountPercentage-field"  // ✅ ADDED
//                     control={control}
//                     name="discountPercentage"
//                     rules={{
//                       required: "Discount is required",
//                       min: { value: 0, message: "Cannot be negative" },
//                       max: { value: 100, message: "Cannot exceed 100%" },
//                     }}
//                     label="Discount (%) *"
//                     type={TextType.Number}
//                   />
//                 </Grid>
//               </Grid>
//             </Paper>
//           </Grid>

//           <Grid item xs={12} sm={8}>
//             <Paper elevation={0} style={{ padding: 20, borderRadius: "8px" }}>
//               <Typography sx={{ fontSize: "1rem", fontWeight: "bold", mb: 2 }}>Preparation Instructions</Typography>
//               <WSTextAreaField
//                 id="preparationInstructions-field"  // ✅ ADDED
//                 control={control}
//                 name="preparationInstructions"
//                 rules={{ required: false }}
//                 label="Type Here"
//                 rows={3}
//               />
//             </Paper>
//           </Grid>
//         </Grid>

//         {/* Test Details */}
//         <Paper elevation={0} style={{ padding: 20, marginTop: 20, borderRadius: "8px" }}>
//           <Grid container spacing={2}>
//             <Grid item xs={12}>
//               <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Test / Package Details</Typography>
//             </Grid>
            
//             <Grid item xs={12} sm={3}>
//               <WSTextField
//                 id="turnaroundTime-field"   // ✅ ADDED
//                 control={control}
//                 name="turnaroundTime"
//                 rules={{ required: "Turnaround time is required" }}
//                 label="Turn Around Time (TAT) *"
//               />
//             </Grid>

//             <Grid item xs={12} sm={2}>
//               <WSTextField
//                 id="sampleRequired-field"   // ✅ ADDED
//                 control={control}
//                 name="sampleRequired"
//                 rules={{ required: "Sample required is required" }}
//                 label="Sample Required *"
//               />
//             </Grid>

//             <Grid item xs={12} sm={3}>
//               <WSTextField
//                 id="numberOfSubTests-field" // ✅ ADDED
//                 control={control}
//                 name="numberOfSubTests"
//                 rules={{
//                   required: "Number of sub-tests is required",
//                   min: { value: 0, message: "Must be 0 or more" },
//                 }}
//                 label="Number Of Sub-Tests *"
//                 type={TextType.Number}
//               />
//             </Grid>

//             <Grid item xs={12} sm={1}>
//               <Button size="small" variant="outlined" sx={{ color: "#098963" }} onClick={handleView} type="button">
//                 View All
//               </Button>
//             </Grid>

//             <Grid item xs={12} sm={2}>
//               <Typography fontSize="0.7rem">At Home Collection</Typography>
//               <Controller
//                 name="isHomeCollectionAvailable"
//                 control={control}
//                 render={({ field }) => (
//                   <Switch
//                     {...field}
//                     checked={Boolean(field.value)}
//                     onChange={(e) => field.onChange(e.target.checked)}
//                     sx={{
//                       "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "#098963" },
//                       "& .MuiSwitch-switchBase.Mui-checked": { color: "#098963" },
//                     }}
//                   />
//                 )}
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <WSTextAreaField
//                 id="aboutTest-field"        // ✅ ADDED
//                 control={control}
//                 name="aboutTest"
//                 rules={{ required: false }}
//                 label="About This Test"
//                 rows={2}
//               />
//             </Grid>

//             <Grid item xs={12} sm={3}>
//               <WSTextField
//                 id="whyChooseTest-field"    // ✅ ADDED
//                 control={control}
//                 name="whyChooseTest"
//                 rules={{ required: "Why choose this test is required" }}
//                 label="Why Choose This Test *"
//               />
//             </Grid>
//           </Grid>
//         </Paper>

//         {/* Highlights */}
//         <Grid container spacing={2} mt={2}>
//           <Grid item xs={12} sm={4}>
//             <Paper elevation={0} style={{ padding: 20, marginTop: 20, borderRadius: "8px" }}>
//               <Typography sx={{ fontSize: "1rem", fontWeight: "bold", mb: 2 }}>Highlights</Typography>
//               <Grid container spacing={2}>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="isRecommended"
//                     control={control}
//                     render={({ field }) => (
//                       <>
//                         <Typography fontSize="0.7rem">Recommended</Typography>
//                         <Switch
//                           {...field}
//                           checked={Boolean(field.value)}
//                           onChange={(e) => field.onChange(e.target.checked)}
//                           sx={{
//                             "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "#098963" },
//                             "& .MuiSwitch-switchBase.Mui-checked": { color: "#098963" },
//                           }}
//                         />
//                       </>
//                     )}
//                   />
//                 </Grid>
//                 {/* <Grid item xs={12} sm={6}>
//                   <Typography fontSize="0.7rem">Active</Typography>
//                   <Controller
//                     name="isActive"
//                     control={control}
//                     render={({ field }) => (
//                       <Switch
//                         {...field}
//                         checked={Boolean(field.value)}
//                         onChange={(e) => field.onChange(e.target.checked)}
//                         sx={{ "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "#098963" } }}
//                       />
//                     )}
//                   />
//                 </Grid> */}
//                  <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="isActive"
//                     control={control}
//                     render={({ field }) => (
//                       <>
//                         <Typography fontSize="0.7rem">Active</Typography>
//                         <Switch
//                           {...field}
//                           checked={Boolean(field.value)}
//                           onChange={(e) => field.onChange(e.target.checked)}
//                         sx={{
//                             "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "#098963" },
//                             "& .MuiSwitch-switchBase.Mui-checked": { color: "#098963" },
//                           }}
//                         />
//                       </>
//                     )}
//                   />
//                 </Grid>
//               </Grid>
//             </Paper>
//           </Grid>
//         </Grid>

//         {/* Buttons */}
//         <Grid container justifyContent="flex-end" spacing={2} sx={{ mt: 2 }}>
//           <Grid item>
//             <WSButton
//               id="cancel"
//               type="button"
//               label="Cancel"
//               size="medium"
//               onClick={handleCancelClick}
//               variant="outlined"
//               color="primary"
//               sx={{
//                 borderRadius: 8,
//                 width: "8rem",
//                 border: "1px solid #098963",
//                 color: "#098963",
//                 backgroundColor: "#FFFFFF",
//               }}
//             />
//           </Grid>


//           <Grid item>
//             <WSButton
//               id="submit"
//               type="submit"
//               label={loading ? "Saving..." : (id ? "Update" : "Add")}
//               size="medium"
//               variant="contained"
//               color="primary"
//               loading={loading}
//               disabled={loading}
//               sx={{
//                 borderRadius: 8,
//                 width: "8rem",
//                 backgroundColor: "#098963",
//                 "&:hover": {
//                   backgroundColor: "#066e4f",
//                 },
//               }}
//             />
//           </Grid>
//           <SwipeableDrawerForm
//             anchor="right"
//             title=""
//             openForm={open}
//             isEdit={true}
//             formComponent={formComponent}
//             onClose={() => {
//               reset();
//               setOpen(false);
//               setFormComponent(null);
//             }}
//           />
//         </Grid>
//       </form>
//     </>
//   );
// });

// export default LabTestPackage;

















// import { Button, Grid, Paper, Switch, Typography } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import WSTextField, { TextType } from "../../../Components/TextBox/WSTextBox";
// import WSSelectField from "../../../Components/Select/WSSelect";
// import { Controller, useForm } from "react-hook-form";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
// import { useNavigate, useParams } from "react-router-dom";
// import WSTextAreaField from "../../../Components/WSTextArea/WSTextArea";
// import WSButton from "../../../Components/Button/WSButton";
// import WSBackButton from "../../../Components/BackButton/BackButton";
// import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";
// import ParametersViewDrawer from "./ParametersView";
// import clientconfig from "../../../Config/clientConfig.json";
// import {
//   callAPI,
//   getLocalValue,
//   LoacalVariables,
//   Method,
// } from "../../../commonFunctions/CommonFunctions";
// import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
// import WSHiddenField from "../../../Components/HiddenField/WSHiddenField";

// interface LabTestFormData {
//   labId: string;
//   name: string;
//   alsoKnownAs: string;
//   labCategoryId: string | null;
//   testType: string;
//   mrpPrice: string;
//   discountPercentage: string;
//   preparationInstructions: string;
//   turnaroundTime: string;
//   sampleRequired: string;
//   numberOfSubTests: string;
//   isHomeCollectionAvailable: boolean;
//   aboutTest: string;
//   whyChooseTest: string;
//   isRecommended: boolean;
//   isActive: boolean;
// }

// export const LabTestPackage: React.FC<any> = React.memo((props) => {
//   const methods = useForm<LabTestFormData>({
//     defaultValues: {
//       labId: "",
//       name: "",
//       alsoKnownAs: "",
//       labCategoryId: null,
//       testType: "",
//       mrpPrice: "",
//       discountPercentage: "",
//       preparationInstructions: "",
//       turnaroundTime: "",
//       sampleRequired: "",
//       numberOfSubTests: "",
//       isHomeCollectionAvailable: false,
//       aboutTest: "",
//       whyChooseTest: "",
//       isRecommended: false,
//       isActive: true,
//     },
//   });

//   const {
//     control,
//     register,
//     handleSubmit,
//     setValue,
//     reset,
//     watch,
//     formState: { errors },
//   } = methods;

//   const [loading, setLoading] = useState<boolean>(false);
//   const navigate = useNavigate();
//   const [open, setOpen] = React.useState(false);
//   const [formComponent, setFormComponent] = useState<any>();
//   const [labId, setLabId] = useState<string>("");
//   const { showMessage } = useSnackbar();
//   const params = useParams();
//   const id = params?.id;

//   // Set labId FIRST
//   useEffect(() => {
//     console.log("🎯 STEP 1 - Setting labId. ID:", id);
//     const userId = getLocalValue(LoacalVariables.UserId) || "";
//     const finalLabId = id || userId || "";
//     console.log("🔗 Final labId:", finalLabId);
//     setLabId(finalLabId);
//     if (finalLabId) {
//       setValue("labId", finalLabId);
//     }
//   }, [id, setValue]);

//   // Load edit data SECOND
//   useEffect(() => {
//     if (!id || !labId) {
//       console.log("⏳ No ID or labId yet");
//       return;
//     }

//     let isCurrent = true;
//     const loadData = async () => {
//       try {
//         setLoading(true);
//         console.log("🚀 FETCHING:", `lab/LabService/${id}`);
//         const response = await callAPI(`lab/LabService/${id}`, Method.GET);
//         console.log("✅ RESPONSE:", response);

//         const data = response?.data || response;
//         if (data && isCurrent) {
//           const formData = {
//             labId: data.labId || labId,
//             name: data.name || "",
//             alsoKnownAs: data.alsoKnownAs || "",
//             labCategoryId: data.labCategoryId || null,
//             testType: data.testType || "",
//             mrpPrice: data.mrpPrice?.toString() || "0",
//             discountPercentage: data.discountPercentage?.toString() || "0",
//             preparationInstructions: data.preparationInstructions || "",
//             turnaroundTime: data.turnaroundTime || "",
//             sampleRequired: data.sampleRequired || "",
//             numberOfSubTests: data.numberOfSubTests?.toString() || "0",
//             isHomeCollectionAvailable: Boolean(data.isHomeCollectionAvailable),
//             aboutTest: data.aboutTest || "",
//             whyChooseTest: data.whyChooseTest || "",
//             isRecommended: Boolean(data.isRecommended),
//             isActive: data.isActive !== undefined ? Boolean(data.isActive) : true,
//           };
//           console.log("📝 POPULATING FORM:", formData);
//           reset(formData);
//         }
//       } catch (error: any) {
//         console.error("💥 ERROR:", error);
//         showMessage(error?.response?.data?.message || "Failed to load data", "error");
//       } finally {
//         if (isCurrent) setLoading(false);
//       }
//     };

//     loadData();
//     return () => { isCurrent = false; };
//   }, [id, labId, reset, showMessage]);

//   useEffect(() => {
//     breadCrumbsStore.updateBreadCrumbs([
//       { "Lab Test & Packages": "labtestpackage/list" },
//       { [id ? "Update Test / Package / Scan" : "Add New Test / Package / Scan"]: "/" },
//     ]);
//   }, [id]);

//   const categorySource = {
//     url: "lab/LabCategory/search",
//     page: 1,
//     pageSize: 10,
//     filter: [],
//     sort: [],
//   };

//   const transFormDataCategory = (data: any) => {
//     const category: Array<any> = [];
//     if (data) {
//       data.map((item: any) => category.push({ label: item.name, value: item.id }));
//     }
//     return category;
//   };

//   const handleCancelClick = () => navigate("/labtestpackage/list");

//   const handleView = () => {
//     const form: any = (
//       <ParametersViewDrawer
//         id="parametersAdd"
//         control={control}
//         register={register}
//         reset={reset}
//         setValue={setValue}
//         onCancel={() => {
//           reset();
//           setOpen(false);
//           setFormComponent(null);
//         }}
//       />
//     );
//     setFormComponent(form);
//     setTimeout(() => setOpen(true), 10);
//   };

//   const saveData = async (data: LabTestFormData) => {
//   const requestBody = {
//     labId: data.labId || labId || "",
//     name: data.name,
//     alsoKnownAs: data.alsoKnownAs,
//     labCategoryId: data.labCategoryId || "",
//     testType: data.testType,
//     mrpPrice: parseFloat(data.mrpPrice) || 0,
//     discountPercentage: parseFloat(data.discountPercentage) || 0,
//     preparationInstructions: data.preparationInstructions,
//     turnaroundTime: data.turnaroundTime,
//     sampleRequired: data.sampleRequired,
//     numberOfSubTests: parseInt(data.numberOfSubTests) || 0,
//     isHomeCollectionAvailable: data.isHomeCollectionAvailable,
//     aboutTest: data.aboutTest,
//     whyChooseTest: data.whyChooseTest,
//     isRecommended: data.isRecommended,
//     isActive: data.isActive,
//     id: id || ""  // ✅ Include ID for updates
//   };

//   try {
//     let response: any;
    
//     if (id) {
//       // ✅ 405 FIX: Use POST for updates (pharmacy APIs do this)
//       console.log("🔄 UPDATING with POST /lab/LabService/update");
//       response = await callAPI("lab/LabService/update", Method.POST, requestBody);
//     } else {
//       // ✅ CREATE - POST works
//       console.log("➕ CREATING with POST /lab/LabService");
//       response = await callAPI("lab/LabService", Method.POST, requestBody);
//     }
    
//     console.log("✅ SUCCESS:", response);
//     return response?.data || response || { success: true };
    
//   } catch (error: any) {
//     console.error("💥 ERROR:", error.response?.status, error.message);
//     throw new Error(error?.response?.data?.message || "Save failed");
//   }
// };




//   const handleData = async (data: LabTestFormData) => {
//     try {
//       setLoading(true);
//       await saveData(data);
//       showMessage(id ? "Updated successfully!" : "Created successfully!", "success");
//       navigate("/labtestpackage/list");
//     } catch (error: any) {
//       showMessage(error.message || "Save failed", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <WSBackButton id="btnScheduleBack" url="/labtestpackage/list" />
      
//       {/* 🔍 DEBUG PANEL */}
//       {/* <Paper elevation={2} sx={{ p: 2, mt: 2, mb: 2, backgroundColor: '#e3f2fd' }}>
//         <Typography variant="h6">🔍 DEBUG</Typography>
//         <Grid container spacing={1}>
//           <Grid item xs={6}><strong>ID:</strong> {id || 'NONE'}</Grid>
//           <Grid item xs={6}><strong>Lab ID:</strong> {labId || 'NONE'}</Grid>
//           <Grid item xs={6}><strong>Loading:</strong> {loading.toString()}</Grid>
//           <Grid item xs={6}><strong>Name:</strong> {watch("name") || 'EMPTY'}</Grid>
//         </Grid>
//       </Paper> */}

//       <form onSubmit={handleSubmit(handleData)}>
//         {/* ✅ ALL FIELDS HAVE id PROPS */}
//         <Paper elevation={0} style={{ padding: 20, marginTop: 20, borderRadius: "8px" }}>
//           <Grid container spacing={2}>
//             <Grid item xs={12}>
//               <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Basic Information</Typography>
//             </Grid>
//             <WSHiddenField control={control} name="labId" />
            
//             <Grid item xs={12} sm={10}>
//               <WSTextField
//                 id="name-field"          
//                 control={control}
//                 name="name"
//                 rules={{ required: "Name is required" }}
//                 label="Name *"
//               />
//             </Grid>

//             <Grid item xs={12} sm={2}>
//               <WSSelectField
//                 id="testType"       
//                 control={control}
//                 rules={{ required: "Test type is required" }}
//                 name="testType"
//                 label="Type *"
//                 options={clientconfig.typeConfig.staticOptionData}
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <WSTextField
//                 id="alsoKnownAs-field"    // ✅ ADDED
//                 control={control}
//                 name="alsoKnownAs"
//                 rules={{ required: "Also known as is required" }}
//                 label="Also Known As *"
//               />
//             </Grid>

//             <Grid item xs={12} sm={4}>
//               <WSSelectField
//                 id="labCategoryId"  // ✅ ADDED
//                 control={control}
//                 rules={{ required: "Category is required" }}
//                 name="labCategoryId"
//                 source={categorySource}
//                 transFormData={transFormDataCategory}
//                 label="Category *"
//               />
//             </Grid>
//           </Grid>
//         </Paper>

//         {/* Pricing & Preparation */}
//         <Grid container spacing={2} mt={2}>
//           <Grid item xs={12} sm={4}>
//             <Paper elevation={0} style={{ padding: 20, borderRadius: "8px" }}>
//               <Typography sx={{ fontSize: "1rem", fontWeight: "bold", mb: 2 }}>Pricing</Typography>
//               <Grid container spacing={2}>
//                 <Grid item xs={12} sm={6}>
//                   <WSTextField
//                     id="mrpPrice-field"       // ✅ ADDED
//                     control={control}
//                     name="mrpPrice"
//                     rules={{
//                       required: "MRP Price is required",
//                       pattern: { value: /^[0-9]+(\.[0-9]{1,2})?$/, message: "Enter valid price" },
//                     }}
//                     label="MRP Price *"
//                     type={TextType.Number}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <WSTextField
//                     id="discountPercentage-field"  // ✅ ADDED
//                     control={control}
//                     name="discountPercentage"
//                     rules={{
//                       required: "Discount is required",
//                       min: { value: 0, message: "Cannot be negative" },
//                       max: { value: 100, message: "Cannot exceed 100%" },
//                     }}
//                     label="Discount (%) *"
//                     type={TextType.Number}
//                   />
//                 </Grid>
//               </Grid>
//             </Paper>
//           </Grid>

//           <Grid item xs={12} sm={8}>
//             <Paper elevation={0} style={{ padding: 20, borderRadius: "8px" }}>
//               <Typography sx={{ fontSize: "1rem", fontWeight: "bold", mb: 2 }}>Preparation Instructions</Typography>
//               <WSTextAreaField
//                 id="preparationInstructions-field"  // ✅ ADDED
//                 control={control}
//                 name="preparationInstructions"
//                 rules={{ required: false }}
//                 label="Type Here"
//                 rows={3}
//               />
//             </Paper>
//           </Grid>
//         </Grid>

//         {/* Test Details */}
//         <Paper elevation={0} style={{ padding: 20, marginTop: 20, borderRadius: "8px" }}>
//           <Grid container spacing={2}>
//             <Grid item xs={12}>
//               <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Test / Package Details</Typography>
//             </Grid>
            
//             <Grid item xs={12} sm={3}>
//               <WSTextField
//                 id="turnaroundTime-field"   // ✅ ADDED
//                 control={control}
//                 name="turnaroundTime"
//                 rules={{ required: "Turnaround time is required" }}
//                 label="Turn Around Time (TAT) *"
//               />
//             </Grid>

//             <Grid item xs={12} sm={2}>
//               <WSTextField
//                 id="sampleRequired-field"   // ✅ ADDED
//                 control={control}
//                 name="sampleRequired"
//                 rules={{ required: "Sample required is required" }}
//                 label="Sample Required *"
//               />
//             </Grid>

//             <Grid item xs={12} sm={3}>
//               <WSTextField
//                 id="numberOfSubTests-field" // ✅ ADDED
//                 control={control}
//                 name="numberOfSubTests"
//                 rules={{
//                   required: "Number of sub-tests is required",
//                   min: { value: 0, message: "Must be 0 or more" },
//                 }}
//                 label="Number Of Sub-Tests *"
//                 type={TextType.Number}
//               />
//             </Grid>

//             <Grid item xs={12} sm={1}>
//               <Button size="small" variant="outlined" sx={{ color: "#098963" }} onClick={handleView} type="button">
//                 View All
//               </Button>
//             </Grid>

//             <Grid item xs={12} sm={2}>
//               <Typography fontSize="0.7rem">At Home Collection</Typography>
//               <Controller
//                 name="isHomeCollectionAvailable"
//                 control={control}
//                 render={({ field }) => (
//                   <Switch
//                     {...field}
//                     checked={Boolean(field.value)}
//                     onChange={(e) => field.onChange(e.target.checked)}
//                     sx={{
//                       "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "#098963" },
//                       "& .MuiSwitch-switchBase.Mui-checked": { color: "#098963" },
//                     }}
//                   />
//                 )}
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <WSTextAreaField
//                 id="aboutTest-field"        // ✅ ADDED
//                 control={control}
//                 name="aboutTest"
//                 rules={{ required: false }}
//                 label="About This Test"
//                 rows={2}
//               />
//             </Grid>

//             <Grid item xs={12} sm={3}>
//               <WSTextField
//                 id="whyChooseTest-field"    // ✅ ADDED
//                 control={control}
//                 name="whyChooseTest"
//                 rules={{ required: "Why choose this test is required" }}
//                 label="Why Choose This Test *"
//               />
//             </Grid>
//           </Grid>
//         </Paper>

//         {/* Highlights */}
//         <Grid container spacing={2} mt={2}>
//           <Grid item xs={12} sm={4}>
//             <Paper elevation={0} style={{ padding: 20, marginTop: 20, borderRadius: "8px" }}>
//               <Typography sx={{ fontSize: "1rem", fontWeight: "bold", mb: 2 }}>Highlights</Typography>
//               <Grid container spacing={2}>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="isRecommended"
//                     control={control}
//                     render={({ field }) => (
//                       <>
//                         <Typography fontSize="0.7rem">Recommended</Typography>
//                         <Switch
//                           {...field}
//                           checked={Boolean(field.value)}
//                           onChange={(e) => field.onChange(e.target.checked)}
//                           sx={{
//                             "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "#098963" },
//                             "& .MuiSwitch-switchBase.Mui-checked": { color: "#098963" },
//                           }}
//                         />
//                       </>
//                     )}
//                   />
//                 </Grid>
//                 {/* <Grid item xs={12} sm={6}>
//                   <Typography fontSize="0.7rem">Active</Typography>
//                   <Controller
//                     name="isActive"
//                     control={control}
//                     render={({ field }) => (
//                       <Switch
//                         {...field}
//                         checked={Boolean(field.value)}
//                         onChange={(e) => field.onChange(e.target.checked)}
//                         sx={{ "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "#098963" } }}
//                       />
//                     )}
//                   />
//                 </Grid> */}
//                  <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="isActive"
//                     control={control}
//                     render={({ field }) => (
//                       <>
//                         <Typography fontSize="0.7rem">Active</Typography>
//                         <Switch
//                           {...field}
//                           checked={Boolean(field.value)}
//                           onChange={(e) => field.onChange(e.target.checked)}
//                         sx={{
//                             "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "#098963" },
//                             "& .MuiSwitch-switchBase.Mui-checked": { color: "#098963" },
//                           }}
//                         />
//                       </>
//                     )}
//                   />
//                 </Grid>
//               </Grid>
//             </Paper>
//           </Grid>
//         </Grid>

//         {/* Buttons */}
//         <Grid container justifyContent="flex-end" spacing={2} sx={{ mt: 2 }}>
//           <Grid item>
//             <WSButton
//               id="cancel"
//               type="button"
//               label="Cancel"
//               size="medium"
//               onClick={handleCancelClick}
//               variant="outlined"
//               color="primary"
//               sx={{
//                 borderRadius: 8,
//                 width: "8rem",
//                 border: "1px solid #098963",
//                 color: "#098963",
//                 backgroundColor: "#FFFFFF",
//               }}
//             />
//           </Grid>


//           <Grid item>
//             <WSButton
//               id="submit"
//               type="submit"
//               label={loading ? "Saving..." : (id ? "Update" : "Add")}
//               size="medium"
//               variant="contained"
//               color="primary"
//               loading={loading}
//               disabled={loading}
//               sx={{
//                 borderRadius: 8,
//                 width: "8rem",
//                 backgroundColor: "#098963",
//                 "&:hover": {
//                   backgroundColor: "#066e4f",
//                 },
//               }}
//             />
//           </Grid>
//           <SwipeableDrawerForm
//             anchor="right"
//             title=""
//             openForm={open}
//             isEdit={true}
//             formComponent={formComponent}
//             onClose={() => {
//               reset();
//               setOpen(false);
//               setFormComponent(null);
//             }}
//           />
//         </Grid>
//       </form>
//     </>
//   );
// });

// export default LabTestPackage;





// import { Button, Grid, Paper, Switch, Typography } from "@mui/material";
// import React, { useEffect, useState, useCallback } from "react";
// import WSTextField, { TextType } from "../../../Components/TextBox/WSTextBox";
// import WSSelectField from "../../../Components/Select/WSSelect";
// import { Controller, useForm } from "react-hook-form";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
// import { useNavigate, useParams } from "react-router-dom";
// import WSTextAreaField from "../../../Components/WSTextArea/WSTextArea";
// import WSButton from "../../../Components/Button/WSButton";
// import WSBackButton from "../../../Components/BackButton/BackButton";
// import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";
// import ParametersViewDrawer from "./ParametersView";
// import clientconfig from "../../../Config/clientConfig.json";
// import http from "../../../commonFunctions/httpClient";// ✅ UPDATE THIS PATH TO YOUR httpClient
// import { getLocalValue, LoacalVariables } from "../../../commonFunctions/CommonFunctions";
// import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
// import WSHiddenField from "../../../Components/HiddenField/WSHiddenField";

// // ✅ TYPE DEFINITIONS - FIXES ALL TS ERRORS
// interface LabTestFormData {
//   labId: string;
//   name: string;
//   alsoKnownAs: string;
//   labCategoryId: string | null;
//   testType: string;
//   mrpPrice: string;
//   discountPercentage: string;
//   preparationInstructions: string;
//   turnaroundTime: string;
//   sampleRequired: string;
//   numberOfSubTests: string;
//   isHomeCollectionAvailable: boolean;
//   aboutTest: string;
//   whyChooseTest: string;
//   isRecommended: boolean;
//   isActive: boolean;
// }

// interface LabTestApiResponse {
//   labId?: string;
//   name?: string;
//   alsoKnownAs?: string;
//   labCategoryId?: string | null;
//   testType?: string;
//   mrpPrice?: number;
//   discountPercentage?: number;
//   preparationInstructions?: string;
//   turnaroundTime?: string;
//   sampleRequired?: string;
//   numberOfSubTests?: number;
//   isHomeCollectionAvailable?: boolean;
//   aboutTest?: string;
//   whyChooseTest?: string;
//   isRecommended?: boolean;
//   isActive?: boolean;
//   data?: LabTestApiResponse; // For nested responses
// }

// export const LabTestPackage: React.FC<any> = React.memo((props) => {
//   const methods = useForm<LabTestFormData>({
//     defaultValues: {
//       labId: "",
//       name: "",
//       alsoKnownAs: "",
//       labCategoryId: null,
//       testType: "",
//       mrpPrice: "",
//       discountPercentage: "",
//       preparationInstructions: "",
//       turnaroundTime: "",
//       sampleRequired: "",
//       numberOfSubTests: "",
//       isHomeCollectionAvailable: false,
//       aboutTest: "",
//       whyChooseTest: "",
//       isRecommended: false,
//       isActive: true,
//     },
//   });

//   const {
//     control,
//     register,
//     handleSubmit,
//     setValue,
//     reset,
//     watch,
//     formState: { errors },
//   } = methods;

//   const [loading, setLoading] = useState<boolean>(false);
//   const navigate = useNavigate();
//   const [open, setOpen] = React.useState(false);
//   const [formComponent, setFormComponent] = useState<any>();
//   const [labId, setLabId] = useState<string>("");
//   const { showMessage } = useSnackbar();
//   const params = useParams();
//   const id = params?.id;

//   // ✅ STEP 1: Set USER ID from localStorage
//   useEffect(() => {
//     const userId = getLocalValue(LoacalVariables.UserId) || "";
//     console.log("🔗 USER ID (labId):", userId, "ROW ID:", id);
//     setLabId(userId);
//     if (userId) setValue("labId", userId);
//   }, []);

//   // ✅ STEP 2: Load data - TYPE SAFE
//   useEffect(() => {
//     if (!id) {
//       console.log("⏳ No ROW ID - CREATE mode");
//       return;
//     }

//     let isCurrent = true;
//     const loadData = async () => {
//       try {
//         setLoading(true);
//         console.log("🚀 LOADING:", `lab/LabService/${id}`);
        
//         const response = await http.get<LabTestApiResponse>(`lab/LabService/${id}`);
//         console.log("✅ LOAD RESPONSE:", response);

//         const apiData = (response as any)?.data || response;
//         if (apiData && isCurrent) {
//           const formData: LabTestFormData = {
//             labId: labId || (apiData as any).labId || "",
//             name: (apiData as any).name || "",
//             alsoKnownAs: (apiData as any).alsoKnownAs || "",
//             labCategoryId: (apiData as any).labCategoryId || null,
//             testType: (apiData as any).testType || "",
//             mrpPrice: ((apiData as any).mrpPrice || 0).toString(),
//             discountPercentage: ((apiData as any).discountPercentage || 0).toString(),
//             preparationInstructions: (apiData as any).preparationInstructions || "",
//             turnaroundTime: (apiData as any).turnaroundTime || "",
//             sampleRequired: (apiData as any).sampleRequired || "",
//             numberOfSubTests: ((apiData as any).numberOfSubTests || 0).toString(),
//             isHomeCollectionAvailable: Boolean((apiData as any).isHomeCollectionAvailable),
//             aboutTest: (apiData as any).aboutTest || "",
//             whyChooseTest: (apiData as any).whyChooseTest || "",
//             isRecommended: Boolean((apiData as any).isRecommended),
//             isActive: Boolean((apiData as any).isActive),
//           };
//           console.log("📝 FORM DATA:", formData);
//           reset(formData);
//         }
//       } catch (error: any) {
//         console.error("💥 LOAD ERROR:", error);
//         showMessage(error?.message || "Failed to load data", "error");
//       } finally {
//         if (isCurrent) setLoading(false);
//       }
//     };

//     loadData();
//     return () => { isCurrent = false; };
//   }, [id, labId, reset, showMessage]);

//   // Breadcrumbs
//   useEffect(() => {
//     breadCrumbsStore.updateBreadCrumbs([
//       { "Lab Test & Packages": "labtestpackage/list" },
//       { [id ? "Update Test / Package / Scan" : "Add New Test / Package / Scan"]: "/" },
//     ]);
//   }, [id]);

//   const categorySource = {
//     url: "lab/LabCategory/search",
//     page: 1,
//     pageSize: 10,
//     filter: [],
//     sort: [],
//   };

//   const transFormDataCategory = (data: any) => {
//     const category: Array<any> = [];
//     if (data) {
//       data.map((item: any) => category.push({ label: item.name, value: item.id }));
//     }
//     return category;
//   };

//   const handleCancelClick = () => navigate("/labtestpackage/list");

//   const handleView = useCallback(() => {
//     const form: any = (
//       <ParametersViewDrawer
//         id="parametersAdd"
//         control={control}
//         register={register}
//         reset={reset}
//         setValue={setValue}
//         onCancel={() => {
//           reset();
//           setOpen(false);
//           setFormComponent(null);
//         }}
//       />
//     );
//     setFormComponent(form);
//     setTimeout(() => setOpen(true), 10);
//   }, [control, register, reset, setValue]);

//   // ✅ FIXED saveData using httpClient - POST for updates
//   const saveData = useCallback(async (data: LabTestFormData) => {
//     const requestBody = {
//       labId: data.labId,
//       name: data.name,
//       alsoKnownAs: data.alsoKnownAs,
//       labCategoryId: data.labCategoryId || "",
//       testType: data.testType,
//       mrpPrice: parseFloat(data.mrpPrice) || 0,
//       discountPercentage: parseFloat(data.discountPercentage) || 0,
//       preparationInstructions: data.preparationInstructions,
//       turnaroundTime: data.turnaroundTime,
//       sampleRequired: data.sampleRequired,
//       numberOfSubTests: parseInt(data.numberOfSubTests) || 0,
//       isHomeCollectionAvailable: data.isHomeCollectionAvailable,
//       aboutTest: data.aboutTest,
//       whyChooseTest: data.whyChooseTest,
//       isRecommended: data.isRecommended,
//       isActive: data.isActive,
//     };

//     console.log("✅ SAVE DATA:", { userId: data.labId, rowId: id, payload: requestBody });

//     try {
//       if (id) {
//         // 🔥 TRY POST /lab/LabService/{id} FIRST (your working pattern)
//         console.log("🔄 UPDATE: POST /lab/LabService/", id);
//         const response = await http.post(`lab/LabService/${id}`, requestBody);
//         console.log("✅ UPDATE SUCCESS:", response);

//         // ✅ VERIFY
//         const verifyData = await http.get(`lab/LabService/${id}`);
//         console.log("✅ VERIFIED DATA:", verifyData);
//       } else {
//         console.log("➕ CREATE: POST /lab/LabService");
//         const response = await http.post("lab/LabService", requestBody);
//         console.log("✅ CREATE SUCCESS:", response);
//       }
//       return { success: true };
//     } catch (error: any) {
//       console.error("💥 SAVE ERROR:", {
//         status: error.response?.status,
//         statusText: error.response?.statusText,
//         data: error.response?.data,
//         message: error.message,
//         url: error.config?.url
//       });
//       throw new Error(error?.response?.data?.message || error.message || "Save failed");
//     }
//   }, [id]);

//   const handleData = useCallback(async (data: LabTestFormData) => {
//     try {
//       setLoading(true);
//       await saveData(data);
//       showMessage(id ? "Updated successfully!" : "Created successfully!", "success");
//       navigate("/labtestpackage/list");
//     } catch (error: any) {
//       console.error("🚨 SAVE FAILED:", error);
//       showMessage(error.message || "Save failed", "error");
//     } finally {
//       setLoading(false);
//     }
//   }, [id, saveData, showMessage, navigate]);

//   return (
//     <>
//       <WSBackButton id="btnScheduleBack" url="/labtestpackage/list" />
      
//       <Paper elevation={2} sx={{ p: 2, mt: 2, mb: 2, backgroundColor: '#e3f2fd' }}>
//         <Typography variant="h6">🔍 DEBUG INFO</Typography>
//         <Grid container spacing={1}>
//           <Grid item xs={6}><strong>ID (ROW):</strong> {id || 'NONE'}</Grid>
//           <Grid item xs={6}><strong>Lab ID (USER):</strong> {labId || 'NONE'}</Grid>
//           <Grid item xs={6}><strong>Loading:</strong> {loading.toString()}</Grid>
//           <Grid item xs={6}><strong>Name:</strong> {watch("name") || 'EMPTY'}</Grid>
//         </Grid>
//       </Paper>

//       <form onSubmit={handleSubmit(handleData)}>
//         {/* ALL YOUR EXISTING FORM FIELDS - SAME AS BEFORE */}
//         <Paper elevation={0} style={{ padding: 20, marginTop: 20, borderRadius: "8px" }}>
//           <Grid container spacing={2}>
//             <Grid item xs={12}>
//               <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Basic Information</Typography>
//             </Grid>
//             <WSHiddenField control={control} name="labId" />
            
//             <Grid item xs={12} sm={10}>
//               <WSTextField
//                 id="name-field"
//                 control={control}
//                 name="name"
//                 rules={{ required: "Name is required" }}
//                 label="Name *"
//               />
//             </Grid>

//             <Grid item xs={12} sm={2}>
//               <WSSelectField
//                 id="testType"
//                 control={control}
//                 rules={{ required: "Test type is required" }}
//                 name="testType"
//                 label="Type *"
//                 options={clientconfig.typeConfig.staticOptionData}
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <WSTextField
//                 id="alsoKnownAs-field"
//                 control={control}
//                 name="alsoKnownAs"
//                 rules={{ required: "Also known as is required" }}
//                 label="Also Known As *"
//               />
//             </Grid>

//             <Grid item xs={12} sm={4}>
//               <WSSelectField
//                 id="labCategoryId"
//                 control={control}
//                 rules={{ required: "Category is required" }}
//                 name="labCategoryId"
//                 source={categorySource}
//                 transFormData={transFormDataCategory}
//                 label="Category *"
//               />
//             </Grid>
//           </Grid>
//         </Paper>

//         {/* Pricing & Preparation - SAME AS BEFORE */}
//         <Grid container spacing={2} mt={2}>
//           <Grid item xs={12} sm={4}>
//             <Paper elevation={0} style={{ padding: 20, borderRadius: "8px" }}>
//               <Typography sx={{ fontSize: "1rem", fontWeight: "bold", mb: 2 }}>Pricing</Typography>
//               <Grid container spacing={2}>
//                 <Grid item xs={12} sm={6}>
//                   <WSTextField
//                     id="mrpPrice-field"
//                     control={control}
//                     name="mrpPrice"
//                     rules={{
//                       required: "MRP Price is required",
//                       pattern: { value: /^[0-9]+(\.[0-9]{1,2})?$/, message: "Enter valid price" },
//                     }}
//                     label="MRP Price *"
//                     type={TextType.Number}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <WSTextField
//                     id="discountPercentage-field"
//                     control={control}
//                     name="discountPercentage"
//                     rules={{
//                       required: "Discount is required",
//                       min: { value: 0, message: "Cannot be negative" },
//                       max: { value: 100, message: "Cannot exceed 100%" },
//                     }}
//                     label="Discount (%) *"
//                     type={TextType.Number}
//                   />
//                 </Grid>
//               </Grid>
//             </Paper>
//           </Grid>

//           <Grid item xs={12} sm={8}>
//             <Paper elevation={0} style={{ padding: 20, borderRadius: "8px" }}>
//               <Typography sx={{ fontSize: "1rem", fontWeight: "bold", mb: 2 }}>Preparation Instructions</Typography>
//               <WSTextAreaField
//                 id="preparationInstructions-field"
//                 control={control}
//                 name="preparationInstructions"
//                 rules={{ required: false }}
//                 label="Type Here"
//                 rows={3}
//               />
//             </Paper>
//           </Grid>
//         </Grid>

//         {/* Test Details - SAME AS BEFORE */}
//         <Paper elevation={0} style={{ padding: 20, marginTop: 20, borderRadius: "8px" }}>
//           <Grid container spacing={2}>
//             <Grid item xs={12}>
//               <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Test / Package Details</Typography>
//             </Grid>
            
//             <Grid item xs={12} sm={3}>
//               <WSTextField id="turnaroundTime-field" control={control} name="turnaroundTime" rules={{ required: "Turnaround time is required" }} label="Turn Around Time (TAT) *" />
//             </Grid>

//             <Grid item xs={12} sm={2}>
//               <WSTextField id="sampleRequired-field" control={control} name="sampleRequired" rules={{ required: "Sample required is required" }} label="Sample Required *" />
//             </Grid>

//             <Grid item xs={12} sm={3}>
//               <WSTextField
//                 id="numberOfSubTests-field"
//                 control={control}
//                 name="numberOfSubTests"
//                 rules={{ required: "Number of sub-tests is required", min: { value: 0, message: "Must be 0 or more" } }}
//                 label="Number Of Sub-Tests *"
//                 type={TextType.Number}
//               />
//             </Grid>

//             <Grid item xs={12} sm={1}>
//               <Button size="small" variant="outlined" sx={{ color: "#098963" }} onClick={handleView} type="button">
//                 View All
//               </Button>
//             </Grid>

//             <Grid item xs={12} sm={2}>
//               <Typography fontSize="0.7rem">At Home Collection</Typography>
//               <Controller
//                 name="isHomeCollectionAvailable"
//                 control={control}
//                 render={({ field }) => (
//                   <Switch
//                     {...field}
//                     checked={Boolean(field.value)}
//                     onChange={(e) => field.onChange(e.target.checked)}
//                     sx={{
//                       "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "#098963" },
//                       "& .MuiSwitch-switchBase.Mui-checked": { color: "#098963" },
//                     }}
//                   />
//                 )}
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <WSTextAreaField id="aboutTest-field" control={control} name="aboutTest" rules={{ required: false }} label="About This Test" rows={2} />
//             </Grid>

//             <Grid item xs={12} sm={3}>
//               <WSTextField id="whyChooseTest-field" control={control} name="whyChooseTest" rules={{ required: "Why choose this test is required" }} label="Why Choose This Test *" />
//             </Grid>
//           </Grid>
//         </Paper>

//         {/* Highlights - SAME AS BEFORE */}
//         <Grid container spacing={2} mt={2}>
//           <Grid item xs={12} sm={4}>
//             <Paper elevation={0} style={{ padding: 20, marginTop: 20, borderRadius: "8px" }}>
//               <Typography sx={{ fontSize: "1rem", fontWeight: "bold", mb: 2 }}>Highlights</Typography>
//               <Grid container spacing={2}>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="isRecommended"
//                     control={control}
//                     render={({ field }) => (
//                       <>
//                         <Typography fontSize="0.7rem">Recommended</Typography>
//                         <Switch
//                           {...field}
//                           checked={Boolean(field.value)}
//                           onChange={(e) => field.onChange(e.target.checked)}
//                           sx={{
//                             "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "#098963" },
//                             "& .MuiSwitch-switchBase.Mui-checked": { color: "#098963" },
//                           }}
//                         />
//                       </>
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="isActive"
//                     control={control}
//                     render={({ field }) => (
//                       <>
//                         <Typography fontSize="0.7rem">Active</Typography>
//                         <Switch
//                           {...field}
//                           checked={Boolean(field.value)}
//                           onChange={(e) => field.onChange(e.target.checked)}
//                           sx={{
//                             "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "#098963" },
//                             "& .MuiSwitch-switchBase.Mui-checked": { color: "#098963" },
//                           }}
//                         />
//                       </>
//                     )}
//                   />
//                 </Grid>
//               </Grid>
//             </Paper>
//           </Grid>
//         </Grid>

//         {/* Buttons */}
//         <Grid container justifyContent="flex-end" spacing={2} sx={{ mt: 2 }}>
//           <Grid item>
//             <WSButton
//               id="cancel"
//               type="button"
//               label="Cancel"
//               size="medium"
//               onClick={handleCancelClick}
//               variant="outlined"
//               color="primary"
//               sx={{
//                 borderRadius: 8,
//                 width: "8rem",
//                 border: "1px solid #098963",
//                 color: "#098963",
//                 backgroundColor: "#FFFFFF",
//               }}
//             />
//           </Grid>
//           <Grid item>
//             <WSButton
//               id="submit"
//               type="submit"
//               label={loading ? "Saving..." : (id ? "Update" : "Add")}
//               size="medium"
//               variant="contained"
//               color="primary"
//               loading={loading}
//               disabled={loading}
//               sx={{
//                 borderRadius: 8,
//                 width: "8rem",
//                 backgroundColor: "#098963",
//                 "&:hover": { backgroundColor: "#066e4f" },
//               }}
//             />
//           </Grid>
//           <SwipeableDrawerForm
//             anchor="right"
//             title=""
//             openForm={open}
//             isEdit={true}
//             formComponent={formComponent}
//             onClose={() => {
//               reset();
//               setOpen(false);
//               setFormComponent(null);
//             }}
//           />
//         </Grid>
//       </form>
//     </>
//   );
// });

// export default LabTestPackage;




import { Button, Grid, Paper, Switch, Typography } from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";
import WSTextField, { TextType } from "../../../Components/TextBox/WSTextBox";
import WSSelectField from "../../../Components/Select/WSSelect";
import { Controller, useForm } from "react-hook-form";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import { useNavigate, useParams } from "react-router-dom";
import WSTextAreaField from "../../../Components/WSTextArea/WSTextArea";
import WSButton from "../../../Components/Button/WSButton";
import WSBackButton from "../../../Components/BackButton/BackButton";
import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";
import ParametersViewDrawer from "./ParametersView";
import clientconfig from "../../../Config/clientConfig.json";
import http from "../../../commonFunctions/httpClient"; // ✅ UPDATE THIS PATH TO YOUR httpClient
import { getLocalValue, LoacalVariables } from "../../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import WSHiddenField from "../../../Components/HiddenField/WSHiddenField";

// ✅ TYPE DEFINITIONS - FIXES ALL TS ERRORS
interface LabTestFormData {
  labId: string;
  name: string;
  alsoKnownAs: string;
  labCategoryId: string | null;
  testType: string;
  mrpPrice: string;
  discountPercentage: string;
  preparationInstructions: string;
  turnaroundTime: string;
  sampleRequired: string;
  numberOfSubTests: string;
  isHomeCollectionAvailable: boolean;
  aboutTest: string;
  whyChooseTest: string;
  isRecommended: boolean;
  isActive: boolean;
}

interface LabTestApiResponse {
  labId?: string;
  name?: string;
  alsoKnownAs?: string;
  labCategoryId?: string | null;
  testType?: string;
  mrpPrice?: number;
  discountPercentage?: number;
  preparationInstructions?: string;
  turnaroundTime?: string;
  sampleRequired?: string;
  numberOfSubTests?: number;
  isHomeCollectionAvailable?: boolean;
  aboutTest?: string;
  whyChooseTest?: string;
  isRecommended?: boolean;
  isActive?: boolean;
  data?: LabTestApiResponse; // For nested responses
}

export const LabTestPackage: React.FC<any> = React.memo((props) => {
  const methods = useForm<LabTestFormData>({
    defaultValues: {
      labId: "",
      name: "",
      alsoKnownAs: "",
      labCategoryId: null,
      testType: "",
      mrpPrice: "",
      discountPercentage: "",
      preparationInstructions: "",
      turnaroundTime: "",
      sampleRequired: "",
      numberOfSubTests: "",
      isHomeCollectionAvailable: false,
      aboutTest: "",
      whyChooseTest: "",
      isRecommended: false,
      isActive: true,
    },
  });

  const {
    control,
    register,
    handleSubmit,
    setValue,
    reset,
    watch,
    formState: { errors },
  } = methods;

  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const [formComponent, setFormComponent] = useState<any>();
  const [labId, setLabId] = useState<string>("");
  const { showMessage } = useSnackbar();
  const params = useParams();
  const id = params?.id;

  // ✅ STEP 1: Set USER ID from localStorage
  useEffect(() => {
    const userId = getLocalValue(LoacalVariables.UserId) || "";
    console.log("🔗 USER ID (labId):", userId, "ROW ID:", id);
    setLabId(userId);
    if (userId) setValue("labId", userId);
  }, []);

  // ✅ STEP 2: Load data - TYPE SAFE
  useEffect(() => {
    if (!id) {
      console.log("⏳ No ROW ID - CREATE mode");
      return;
    }

    let isCurrent = true;
    const loadData = async () => {
      try {
        setLoading(true);
        console.log("🚀 LOADING:", `lab/LabService/${id}`);
        
        const response = await http.get<LabTestApiResponse>(`lab/LabService/${id}`);
        console.log("✅ LOAD RESPONSE:", response);

        const apiData = (response as any)?.data || response;
        if (apiData && isCurrent) {
          const formData: LabTestFormData = {
            labId: labId || (apiData as any).labId || "",
            name: (apiData as any).name || "",
            alsoKnownAs: (apiData as any).alsoKnownAs || "",
            labCategoryId: (apiData as any).labCategoryId || null,
            testType: (apiData as any).testType || "",
            mrpPrice: ((apiData as any).mrpPrice || 0).toString(),
            discountPercentage: ((apiData as any).discountPercentage || 0).toString(),
            preparationInstructions: (apiData as any).preparationInstructions || "",
            turnaroundTime: (apiData as any).turnaroundTime || "",
            sampleRequired: (apiData as any).sampleRequired || "",
            numberOfSubTests: ((apiData as any).numberOfSubTests || 0).toString(),
            isHomeCollectionAvailable: Boolean((apiData as any).isHomeCollectionAvailable),
            aboutTest: (apiData as any).aboutTest || "",
            whyChooseTest: (apiData as any).whyChooseTest || "",
            isRecommended: Boolean((apiData as any).isRecommended),
            isActive: Boolean((apiData as any).isActive),
          };
          console.log("📝 FORM DATA:", formData);
          reset(formData);
        }
      } catch (error: any) {
        console.error("💥 LOAD ERROR:", error);
        showMessage(error?.message || "Failed to load data", "error");
      } finally {
        if (isCurrent) setLoading(false);
      }
    };

    loadData();
    return () => { isCurrent = false; };
  }, [id, labId, reset, showMessage]);

  // Breadcrumbs
  useEffect(() => {
    breadCrumbsStore.updateBreadCrumbs([
      { "Lab Test & Packages": "labtestpackage/list" },
      { [id ? "Update Test / Package / Scan" : "Add New Test / Package / Scan"]: "/" },
    ]);
  }, [id]);

  const categorySource = {
    url: "lab/LabCategory/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [],
  };

  const transFormDataCategory = (data: any) => {
    const category: Array<any> = [];
    if (data) {
      data.map((item: any) => category.push({ label: item.name, value: item.id }));
    }
    return category;
  };

  const handleCancelClick = () => navigate("/labtestpackage/list");

  const handleView = useCallback(() => {
    const form: any = (
      <ParametersViewDrawer
        id="parametersAdd"
        control={control}
        register={register}
        reset={reset}
        setValue={setValue}
        onCancel={() => {
          reset();
          setOpen(false);
          setFormComponent(null);
        }}
      />
    );
    setFormComponent(form);
    setTimeout(() => setOpen(true), 10);
  }, [control, register, reset, setValue]);

  // ✅ FIXED saveData using httpClient - POST for updates
  // ✅ FIXED saveData - Handles CREATE perfectly
// ✅ COMPLETE FIXED saveData - Compiles + CREATE works
const saveData = useCallback(async (data: LabTestFormData) => {
  // ✅ VALIDATE before API
  if (!data.name.trim()) throw new Error("Name is required");
  if (!data.testType) throw new Error("Test type is required");
  if (!data.labCategoryId || data.labCategoryId === "") throw new Error("Category is required");

  const requestBody = {
    labId: data.labId|| (saveData as any).labId || "",
    name: data.name.trim(),
    alsoKnownAs: data.alsoKnownAs || "",
    labCategoryId: data.labCategoryId || null,  // ✅ null for backend
    testType: data.testType,
    mrpPrice: parseFloat(data.mrpPrice) || 0,
    discountPercentage: parseFloat(data.discountPercentage) || 0,
    preparationInstructions: data.preparationInstructions || "",
    turnaroundTime: data.turnaroundTime || "",
    sampleRequired: data.sampleRequired || "",
    numberOfSubTests: parseInt(data.numberOfSubTests) || 0,
    isHomeCollectionAvailable: data.isHomeCollectionAvailable,
    aboutTest: data.aboutTest || "",
    whyChooseTest: data.whyChooseTest || "",
    isRecommended: data.isRecommended,
    isActive: data.isActive,
  };

  console.log("🚀 SAVE PAYLOAD:", requestBody);

  try {
    let response: any = null;  // ✅ DECLARE HERE - visible everywhere

    if (id) {
      // 🔥 UPDATE (your working logic)
      console.log("🔄 UPDATE:", id);
      const endpoints = [
        `api/lab/LabService/${id}`,
        `/api/lab/LabService/${id}`,
        `lab/LabService/${id}`,
        `/lab/LabService/${id}`,
      ];

      let lastError;
      for (const endpoint of endpoints) {
        try {
          console.log("🔄 Trying UPDATE:", endpoint);
          response = await http.put(endpoint, requestBody);
          console.log("✅ UPDATE SUCCESS:", endpoint, response);
          break;
        } catch (error: any) {
          console.log("❌ UPDATE failed", endpoint, ":", error.response?.status);
          lastError = error;
          continue;
        }
      }

      if (!response) {
        throw lastError || new Error("All UPDATE endpoints failed");
      }
    } else {
      // ➕ CREATE
      console.log("➕ CREATE - no ID");
      const endpoints = [
        "api/lab/LabService",     // ✅ Your exact endpoint
        "lab/LabService",
        "/api/lab/LabService",
        "/lab/LabService",
      ];

      let lastError;
      for (const endpoint of endpoints) {
        try {
          console.log("🔄 Trying CREATE:", endpoint);
          response = await http.post(endpoint, requestBody);
          console.log("✅ CREATE SUCCESS:", endpoint, response);
          break;
        } catch (error: any) {
          console.error("❌ CREATE failed", endpoint, ":", {
            status: error.response?.status,
            data: error.response?.data,
          });
          lastError = error;
          continue;
        }
      }

      if (!response) {
        throw lastError || new Error("All CREATE endpoints failed - check Network tab");
      }
    }

    // ✅ NOW response is ALWAYS defined
    return { success: true, data: response.data || response };

  } catch (error: any) {
    console.error("💥 FULL SAVE ERROR:", {
      status: error.response?.status,
      message: error.response?.data?.message || error.message,
      url: error.config?.url,
      payload: requestBody,
    });
    throw new Error(error?.response?.data?.message || error.message || "Save failed");
  }
}, [id]);




  const handleData = useCallback(async (data: LabTestFormData) => {
    try {
      setLoading(true);
      await saveData(data);
      showMessage(id ? "Updated successfully!" : "Created successfully!", "success");
      navigate("/labtestpackage/list");
    } catch (error: any) {
      console.error("🚨 SAVE FAILED:", error);
      showMessage(error.message || "Save failed", "error");
    } finally {
      setLoading(false);
    }
  }, [id, saveData, showMessage, navigate]);

  return (
    <>
      <WSBackButton id="btnScheduleBack" url="/labtestpackage/list" />
      
      {/* <Paper elevation={2} sx={{ p: 2, mt: 2, mb: 2, backgroundColor: '#e3f2fd' }}>
        <Typography variant="h6">🔍 DEBUG INFO</Typography>
        <Grid container spacing={1}>
          <Grid item xs={6}><strong>ID (ROW):</strong> {id || 'NONE'}</Grid>
          <Grid item xs={6}><strong>Lab ID (USER):</strong> {labId || 'NONE'}</Grid>
          <Grid item xs={6}><strong>Loading:</strong> {loading.toString()}</Grid>
          <Grid item xs={6}><strong>Name:</strong> {watch("name") || 'EMPTY'}</Grid>
        </Grid>
      </Paper> */}

      <form onSubmit={handleSubmit(handleData)}>
        {/* ALL YOUR EXISTING FORM FIELDS - SAME AS BEFORE */}
        <Paper elevation={0} style={{ padding: 20, marginTop: 20, borderRadius: "8px" }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Basic Information</Typography>
            </Grid>
            <WSHiddenField control={control} name="labId" />
            
            <Grid item xs={12} sm={10}>
              <WSTextField
                id="name-field"
                control={control}
                name="name"
                rules={{ required: "Name is required" }}
                label="Name *"
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <WSSelectField
                id="testType"
                control={control}
                rules={{ required: "Test type is required" }}
                name="testType"
                label="Type *"
                options={clientconfig.typeConfig.staticOptionData}
              />
            </Grid>

            <Grid item xs={12}>
              <WSTextField
                id="alsoKnownAs-field"
                control={control}
                name="alsoKnownAs"
                rules={{ required: "Also known as is required" }}
                label="Also Known As *"
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <WSSelectField
                id="labCategoryId"
                control={control}
                rules={{ required: "Category is required" }}
                name="labCategoryId"
                source={categorySource}
                transFormData={transFormDataCategory}
                label="Category *"
              />
            </Grid>
          </Grid>
        </Paper>

        {/* Pricing & Preparation - SAME AS BEFORE */}
        <Grid container spacing={2} mt={2}>
          <Grid item xs={12} sm={4}>
            <Paper elevation={0} style={{ padding: 20, borderRadius: "8px" }}>
              <Typography sx={{ fontSize: "1rem", fontWeight: "bold", mb: 2 }}>Pricing</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <WSTextField
                    id="mrpPrice-field"
                    control={control}
                    name="mrpPrice"
                    rules={{
                      required: "MRP Price is required",
                      pattern: { value: /^[0-9]+(\.[0-9]{1,2})?$/, message: "Enter valid price" },
                    }}
                    label="MRP Price *"
                    type={TextType.Number}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <WSTextField
                    id="discountPercentage-field"
                    control={control}
                    name="discountPercentage"
                    rules={{
                      required: "Discount is required",
                      min: { value: 0, message: "Cannot be negative" },
                      max: { value: 100, message: "Cannot exceed 100%" },
                    }}
                    label="Discount (%) *"
                    type={TextType.Number}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          <Grid item xs={12} sm={8}>
            <Paper elevation={0} style={{ padding: 20, borderRadius: "8px" }}>
              <Typography sx={{ fontSize: "1rem", fontWeight: "bold", mb: 2 }}>Preparation Instructions</Typography>
              <WSTextAreaField
                id="preparationInstructions-field"
                control={control}
                name="preparationInstructions"
                rules={{ required: false }}
                label="Type Here"
                rows={3}
              />
            </Paper>
          </Grid>
        </Grid>

        {/* Test Details - SAME AS BEFORE */}
        <Paper elevation={0} style={{ padding: 20, marginTop: 20, borderRadius: "8px" }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Test / Package Details</Typography>
            </Grid>
            
            <Grid item xs={12} sm={3}>
              <WSTextField id="turnaroundTime-field" control={control} name="turnaroundTime" rules={{ required: "Turnaround time is required" }} label="Turn Around Time (TAT) *" />
            </Grid>

            <Grid item xs={12} sm={2}>
              <WSTextField id="sampleRequired-field" control={control} name="sampleRequired" rules={{ required: "Sample required is required" }} label="Sample Required *" />
            </Grid>

            <Grid item xs={12} sm={3}>
              <WSTextField
                id="numberOfSubTests-field"
                control={control}
                name="numberOfSubTests"
                rules={{ required: "Number of sub-tests is required", min: { value: 0, message: "Must be 0 or more" } }}
                label="Number Of Sub-Tests *"
                type={TextType.Number}
              />
            </Grid>

            <Grid item xs={12} sm={1}>
              <Button size="small" variant="outlined" sx={{ color: "#098963" }} onClick={handleView} type="button">
                View All
              </Button>
            </Grid>

            <Grid item xs={12} sm={2}>
              <Typography fontSize="0.7rem">At Home Collection</Typography>
              <Controller
                name="isHomeCollectionAvailable"
                control={control}
                render={({ field }) => (
                  <Switch
                    {...field}
                    checked={Boolean(field.value)}
                    onChange={(e) => field.onChange(e.target.checked)}
                    sx={{
                      "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "#098963" },
                      "& .MuiSwitch-switchBase.Mui-checked": { color: "#098963" },
                    }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12}>
              <WSTextAreaField id="aboutTest-field" control={control} name="aboutTest" rules={{ required: false }} label="About This Test" rows={2} />
            </Grid>

            <Grid item xs={12} sm={3}>
              <WSTextField id="whyChooseTest-field" control={control} name="whyChooseTest" rules={{ required: "Why choose this test is required" }} label="Why Choose This Test *" />
            </Grid>
          </Grid>
        </Paper>

        {/* Highlights - SAME AS BEFORE */}
        <Grid container spacing={2} mt={2}>
          <Grid item xs={12} sm={4}>
            <Paper elevation={0} style={{ padding: 20, marginTop: 20, borderRadius: "8px" }}>
              <Typography sx={{ fontSize: "1rem", fontWeight: "bold", mb: 2 }}>Highlights</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="isRecommended"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Typography fontSize="0.7rem">Recommended</Typography>
                        <Switch
                          {...field}
                          checked={Boolean(field.value)}
                          onChange={(e) => field.onChange(e.target.checked)}
                          sx={{
                            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "#098963" },
                            "& .MuiSwitch-switchBase.Mui-checked": { color: "#098963" },
                          }}
                        />
                      </>
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="isActive"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Typography fontSize="0.7rem">Active</Typography>
                        <Switch
                          {...field}
                          checked={Boolean(field.value)}
                          onChange={(e) => field.onChange(e.target.checked)}
                          sx={{
                            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "#098963" },
                            "& .MuiSwitch-switchBase.Mui-checked": { color: "#098963" },
                          }}
                        />
                      </>
                    )}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>

        {/* Buttons */}
        <Grid container justifyContent="flex-end" spacing={2} sx={{ mt: 2 }}>
          <Grid item>
            <WSButton
              id="cancel"
              type="button"
              label="Cancel"
              size="medium"
              onClick={handleCancelClick}
              variant="outlined"
              color="primary"
              sx={{
                borderRadius: 8,
                width: "8rem",
                border: "1px solid #098963",
                color: "#098963",
                backgroundColor: "#FFFFFF",
              }}
            />
          </Grid>
          <Grid item>
            <WSButton
              id="submit"
              type="submit"
              label={loading ? "Saving..." : (id ? "Update" : "Add")}
              size="medium"
              variant="contained"
              color="primary"
              loading={loading}
              disabled={loading}
              sx={{
                borderRadius: 8,
                width: "8rem",
                backgroundColor: "#098963",
                "&:hover": { backgroundColor: "#066e4f" },
              }}
            />
          </Grid>
          <SwipeableDrawerForm
            anchor="right"
            title=""
            openForm={open}
            isEdit={true}
            formComponent={formComponent}
            onClose={() => {
              reset();
              setOpen(false);
              setFormComponent(null);
            }}
          />
        </Grid>
      </form>
    </>
  );
});

export default LabTestPackage;
